import { restoreAuthData } from 'redesign/helpers/auth';

export const getUserId = () => {
    if (process.env.NODE_ENV === 'test') {
        return 1;
    }
    return restoreAuthData()?.user?.id ?? null;
};

export const getUserName = () => {
    const authData = restoreAuthData();
    return authData?.user
        ? [authData.user.firstname, authData.user.lastname].join(' ')
        : 'Pricemoov User';
};

export const getUserEmail = () => restoreAuthData()?.user?.email ?? '';
